import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
  Card,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaChalkboardTeacher} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsEyeFill, BsPencilFill, BsTrashFill, BsThreeDotsVertical, BsFileEarmarkSpreadsheetFill, BsFileEarmarkPdfFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import toast from 'react-hot-toast'
import EditTeacherModal from './EditTeacherModal'
import { Eye, PencilSquare, Trash } from 'react-bootstrap-icons'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { NO_IMAGE_SRC } from '../utils/instituteBranding'

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

async function fetchImageAsDataUrlForPdf(url) {
  if (!url || String(url).startsWith('data:')) return url

  try {
    const res = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (res.ok) {
      return await blobToDataURL(await res.blob())
    }
  } catch {
    /* fall through */
  }

  try {
    const proxiedUrl = `https://images.weserv.nl/?url=${encodeURIComponent(url)}`
    const res = await fetch(proxiedUrl)
    if (res.ok) {
      return await blobToDataURL(await res.blob())
    }
  } catch {
    /* fall through */
  }

  try {
    const proxiedUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`
    const res = await fetch(proxiedUrl)
    if (res.ok) {
      return await blobToDataURL(await res.blob())
    }
  } catch {
    /* ignore */
  }

  return null
}

async function makeWatermarkImageDataUrl(sourceDataUrl, size = 600, opacity = 0.1) {
  if (!sourceDataUrl) return null

  try {
    return await new Promise((resolve, reject) => {
      const imageEl = new Image()
      imageEl.crossOrigin = 'anonymous'
      imageEl.onload = () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = size
          canvas.height = size
          const ctx = canvas.getContext('2d')
          const minSide = Math.min(imageEl.naturalWidth, imageEl.naturalHeight)
          const sx = (imageEl.naturalWidth - minSide) / 2
          const sy = (imageEl.naturalHeight - minSide) / 2

          ctx.clearRect(0, 0, size, size)
          ctx.save()
          ctx.beginPath()
          ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
          ctx.closePath()
          ctx.clip()
          ctx.globalAlpha = opacity
          ctx.drawImage(imageEl, sx, sy, minSide, minSide, 0, 0, size, size)
          ctx.restore()

          resolve(canvas.toDataURL('image/png'))
        } catch (e) {
          reject(e)
        }
      }
      imageEl.onerror = reject
      imageEl.src = sourceDataUrl
    })
  } catch {
    return null
  }
}

const formatTeacherDob = (dob) => {
  if (!dob) return '-'
  return new Date(dob).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

const TeacherTable = () => {
  const { user, logout } = useAuth()
  const { isCollapsed } = useSidebar()
  console.log('USER ', user)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState(null)

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId)}

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/teacher/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setData(response.data.data)
        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [loading])

  // Filter Data Based on Status (Active) and Search
  const filteredData = data.filter((item) => {
    // First filter by status - only show active teachers
    const isActive = item.status?.toLowerCase() === 'active'
    if (!isActive) return false
    
    // Then filter by search term
    return Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    )
  })

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const navigate = useNavigate()
  const handleTeacherProfile = (teacher) => {
    navigate(`/TeacherProfile/${teacher.id}`, { state: { teacher } })
  }
  const getTeacherExportRows = () =>
    filteredData.map((teacher) => ({
      Name: teacher.name || '-',
      'Date of Birth': formatTeacherDob(teacher.dob),
      Qualification: teacher.qualification || '-',
      Phone: teacher.phone || '-',
      Email: teacher.email || '-',
    }))

  const exportToExcel = () => {
    const exportData = getTeacherExportRows()
    if (exportData.length === 0) {
      toast.error('No teacher records to export.')
      return
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Teachers')
    XLSX.writeFile(workbook, 'Teacher_Records.xlsx')
  }

  const exportToPdf = async () => {
    const exportData = getTeacherExportRows()
    if (exportData.length === 0) {
      toast.error('No teacher records to export.')
      return
    }

    try {
      let watermarkDataUrl = null
      if (logo && logo !== NO_IMAGE_SRC) {
        try {
          const raw = await fetchImageAsDataUrlForPdf(logo)
          if (raw) {
            watermarkDataUrl = await makeWatermarkImageDataUrl(raw, 600, 0.1)
          }
        } catch {
          watermarkDataUrl = null
        }
      }

      const doc = new jsPDF('l', 'mm', 'a4')
      const pageWidth = doc.internal.pageSize.getWidth()
      const pageHeight = doc.internal.pageSize.getHeight()
      const margin = 10
      const rowHeight = 8
      let yPos = 22

      const drawCenterWatermark = () => {
        if (!watermarkDataUrl) return
        const wmSize = Math.min(pageWidth, pageHeight) * 0.42
        const cx = (pageWidth - wmSize) / 2
        const cy = (pageHeight - wmSize) / 2
        doc.addImage(watermarkDataUrl, 'PNG', cx, cy, wmSize, wmSize)
      }

      drawCenterWatermark()

      const headers = [
        'Name',
        'Date of Birth',
        'Qualification',
        'Phone',
        'Email',
      ]

      const colWidths = [55, 40, 60, 45, 67]

      const drawTableHeader = () => {
        let xPos = margin
        doc.setFillColor(34, 56, 67)
        doc.rect(margin, yPos, pageWidth - margin * 2, rowHeight, 'F')
        doc.setTextColor(255, 255, 255)
        doc.setFontSize(8)
        doc.setFont('helvetica', 'bold')
        headers.forEach((header, index) => {
          doc.text(header, xPos + 1.5, yPos + 5.5)
          xPos += colWidths[index]
        })
        yPos += rowHeight
      }

      const fitText = (text, maxLength) => {
        const safeText = String(text ?? '')
        if (safeText.length <= maxLength) return safeText
        return `${safeText.slice(0, maxLength - 3)}...`
      }

      const fitTextToColumn = (text, colIndex) => {
        const safeText = String(text ?? '')
        const maxWidth = colWidths[colIndex] - 3
        const lines = doc.splitTextToSize(safeText, maxWidth)
        return lines[0] || ''
      }

      const maxLens = [22, 14, 28, 16, 32]

      const instituteDisplayName = String(
        name || Cookies.get('name') || Cookies.get('institute_name') || '',
      ).trim()

      doc.setFontSize(14)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(34, 56, 67)
      doc.text(instituteDisplayName || 'Institute', pageWidth / 2, 10, {
        align: 'center',
      })

      doc.setFontSize(12)
      doc.text('Teacher Records', pageWidth / 2, 16, {
        align: 'center',
      })

      drawTableHeader()

      doc.setFont('helvetica', 'normal')
      doc.setTextColor(17, 24, 39)
      doc.setFontSize(8)

      exportData.forEach((rowObj, index) => {
        if (yPos + rowHeight > pageHeight - margin) {
          doc.addPage()
          drawCenterWatermark()
          yPos = 14
          drawTableHeader()
          doc.setFont('helvetica', 'normal')
          doc.setTextColor(17, 24, 39)
          doc.setFontSize(8)
        }

        let xPos = margin
        const cells = headers.map((h, i) =>
          h === 'Email' || h === 'Qualification'
            ? fitTextToColumn(rowObj[h], i)
            : fitText(rowObj[h], maxLens[i]),
        )

        if (index % 2 !== 0) {
          doc.setFillColor(249, 250, 251)
          doc.rect(margin, yPos, pageWidth - margin * 2, rowHeight, 'F')
        }

        cells.forEach((cell, colIndex) => {
          doc.text(String(cell), xPos + 1.5, yPos + 5.5)
          xPos += colWidths[colIndex]
        })

        yPos += rowHeight
      })

      doc.save('Teacher_Records.pdf')
    } catch (error) {
      console.error('Error while generating PDF:', error)
      toast.error('Failed to generate PDF.')
    }
  }

  const handleRefresh = async () => {
    setSearch('')
    setCurrentPage(1)
    // Reload teachers data
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
      } catch (err) {
        console.error('Failed to parse user cookie', err)
        return
      }
    }

    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(institueId)}

      const response = await axios.get(
        BASE_URL + '/teacher/all',
        { headers },
      )

      setData(response.data.data || [])
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong')
    }
  }

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }

  // Handle Delete Teacher
  const handleDeleteTeacher = async () => {
    if (!selectedTeacher) return

    try {
      setLoading(true)
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null

      if (userCookie) {
        try {
          const user = JSON.parse(userCookie)
          token = user.token
        } catch (err) {
          console.error('Failed to parse user cookie', err)
          toast.error('Authentication error. Please login again.')
          return
        }
      } else {
        toast.error('User not found. Please login again.')
        return
      }

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(institueId)}

      const response = await axios.post(
        BASE_URL + `/teacher/${selectedTeacher.id}/inactive`,
        {},
        { headers },
      )

      toast.success(response.data.message || 'Teacher deleted successfully')
      setShowDeleteModal(false)
      setSelectedTeacher(null)
      setLoading(true) // Trigger data refresh
    } catch (error) {
      console.error('Delete failed:', error.response?.data || error.message)
      toast.error(
        error.response?.data?.message || 'Failed to delete teacher. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          .table td {
            user-select: text;
            overflow: visible !important;
          }
          .table tbody tr {
            cursor: default;
            overflow: visible !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Teacher Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Teachers
              </h3>
              {/* <button
                onClick={() => navigate('/AddNewTeacher')}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#223843',
                  border: 'none',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Teacher"
              >
                <FaChalkboardTeacher size={18} />
              </button> */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && ( 
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
            <button
              type="button"
              className="d-none d-md-flex align-items-center justify-content-center"
              onClick={() => navigate('/AddNewTeacher')}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New"
            >
              <FaChalkboardTeacher size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New Teacher
              </span>
            </button>
          </div>

          <div className="d-md-none d-flex justify-content-end mb-4">
            <button
              type="button"
              onClick={() => navigate('/AddNewTeacher')}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New"
            >
              <FaChalkboardTeacher size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New Teacher
              </span>
            </button>
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Teachers
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find teachers quickly by name, qualification, phone, or email
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-3">
                    <Col xs={12}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Teacher Name
                        </label>
                        <div style={{ position: 'relative' }}>
                          <BsSearch 
                            style={{ 
                              position: 'absolute', 
                              left: '12px', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              color: '#6b7280',
                              fontSize: '16px',
                              zIndex: 1}} 
                          />
                          <Form.Control
                            type="text"
                            placeholder="Enter teacher name..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                              paddingLeft: '40px',
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
            <button
              type="button"
              onClick={exportToPdf}
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#EF4444',
                border: 'none',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#DC2626'
                e.currentTarget.style.transform = 'scale(1.05)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#EF4444'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Export PDF"
            >
              <BsFileEarmarkPdfFill size={20} />
            </button>
            <button
              type="button"
              onClick={exportToExcel}
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#10B981',
                border: 'none',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#059669'
                e.currentTarget.style.transform = 'scale(1.05)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#10B981'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Export to Excel"
            >
              <BsFileEarmarkSpreadsheetFill size={20} />
            </button>
          </div>

        {/* Table */}
        <Card className="table-card" style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'visible', backgroundColor: '#ffffff', position: 'relative' }}>
          <div className="table-wrapper" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative', marginBottom: '0' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Date of Birth</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Qualification</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Phone</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Email</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{highlightText(item.name, search)}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {formatTeacherDob(item?.dob)}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.qualification}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.phone}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.email}</Td>
                    <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                      {/* Desktop View - Dropdown */}
                      <div className="d-none d-md-block">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            id={`dropdown-${item.id}`}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: 'transparent',
                              border: '1px solid #D1D3D4',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease'}}
                            className="dropdown-toggle-no-caret"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.borderColor = '#223843'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.borderColor = '#D1D3D4'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsThreeDotsVertical style={{ color: 'inherit' }} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              padding: '8px',
                              minWidth: '180px'}}
                          >
                            <Dropdown.Item
                              onClick={() => handleTeacherProfile(item)}
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsEyeFill size={18} /> View Profile
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() => {
                                navigate(`/UpdateTeacherProfile/${item.id}`, { state: { teacher: item } })
                              }}
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#10B981'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsPencilFill size={18} /> Edit Teacher
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() => {
                                setSelectedTeacher(item)
                                setShowDeleteModal(true)
                              }}
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#EF4444'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsTrashFill size={18} /> Delete Teacher
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                        {/* Mobile View - Circular Buttons */}
                        <div className="d-md-none d-flex justify-content-center gap-2">
                          <button
                            onClick={() => handleTeacherProfile(item)}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="View Profile"
                          >
                            <BsEyeFill size={16} />
                          </button>
                          <button
                            onClick={() => {
                              navigate(`/UpdateTeacherProfile/${item.id}`, { state: { teacher: item } })
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Teacher"
                          >
                            <BsPencilFill size={16} />
                          </button>
                          <button
                            onClick={() => {
                              setSelectedTeacher(item)
                              setShowDeleteModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#EF4444',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#DC2626'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#EF4444'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Delete Teacher"
                          >
                            <BsTrashFill size={16} />
                          </button>
                        </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="6" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="teachers"
        />
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="lg">
      <Modal.Header closeButton 
        closeVariant="white"
        className="bg-danger text-dark text-white">
        <Modal.Title>Delete Teacher</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2 fw-semibold" style={{ letterSpacing: '2px' }}>
          Are you sure you want to delete the teacher <strong>{selectedTeacher?.name}</strong>?<br />
          <hr />
          <div className="mt-3 text-muted fw-semibold" style={{ letterSpacing: '2px' }}>
            This action is irreversible and the teacher will be permanently removed.
          </div>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDeleteTeacher}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default TeacherTable
